/* ============================================================
   La Nani — bara de anunț de sus

   Problema: textul e scris o dată, dar telefoanele au lățimi diferite
   iar utilizatorii își pot mări fontul din setările sistemului. Pe un
   ecran îngust cu text mărit, anunțul fie se taie cu trei puncte, fie
   trece pe două rânduri și strică bara.

   Soluția: dacă textul nu încape, îl derulăm continuu de la dreapta la
   stânga și îl reluăm de la început. Dacă încape, îl lăsăm centrat și
   nemișcat — o bară care se mișcă fără motiv obosește degeaba.

   Măsurăm din nou la redimensionare și la schimbarea fontului, pentru
   că amândouă schimbă răspunsul.
   ============================================================ */
(function () {
  'use strict';

  var VITEZA = 55;          /* pixeli pe secundă */
  var MARCAJ = 'lnAnuntGata';

  function bara() {
    return document.querySelector('.announcement-bar__message, .utility-bar .announcement-bar__message');
  }

  function masoara(el) {
    var container = el.parentElement;
    if (!container) return;

    /* pornim de la starea neutră, ca măsurătoarea să fie curată */
    el.classList.remove('ln-anunt--curge');
    var interior = el.querySelector('.ln-anunt__text');
    if (interior) {
      el.textContent = interior.textContent.trim();
    }

    var latimeText = el.scrollWidth;
    var latimeLoc = container.clientWidth;

    /* pragul de 4px acoperă rotunjirile de subpixel */
    if (latimeText <= latimeLoc + 4) return;

    var text = el.textContent.trim();
    /* două copii, ca reluarea să fie continuă, fără gol la mijloc */
    el.innerHTML = '';
    var pista = document.createElement('span');
    pista.className = 'ln-anunt__pista';
    [0, 1].forEach(function (i) {
      var s = document.createElement('span');
      s.className = 'ln-anunt__text';
      s.textContent = text;
      if (i === 1) s.setAttribute('aria-hidden', 'true');
      pista.appendChild(s);
    });
    el.appendChild(pista);
    el.classList.add('ln-anunt--curge');

    var durata = Math.max(6, Math.round((latimeText + 48) / VITEZA));
    pista.style.animationDuration = durata + 's';
  }

  function porneste() {
    var el = bara();
    if (!el) return;
    if (!el.dataset[MARCAJ]) {
      el.dataset[MARCAJ] = '1';
      var reia = 0;
      window.addEventListener('resize', function () {
        clearTimeout(reia);
        reia = setTimeout(function () { masoara(el); }, 200);
      });
      /* fonturile web schimbă lățimea după ce se încarcă */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { masoara(el); });
      }
    }
    masoara(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }
  window.addEventListener('load', porneste);
})();
